/// <amd-module name="Checks/Approvals/Web/Utilities" />

export function deepCopy<T>(object: T): T {
    return JSON.parse(JSON.stringify(object));
}

export function arrayContains<S, T>(value: S, target: T[], comparer?: (s: S, t: T) => boolean): boolean {
    if (!target) {
        return false;
    }

    for (let i = 0, len = target.length; i < len; i++) {
        if (comparer && comparer(value, target[i])) {
            return true;
        }
    }

    return false;
}

export function arrayEquals<S, T>(source: S[], target: T[], comparer?: (s: S, t: T) => boolean): boolean {
    if (!source || !target) {
        return false;
    }

    if (source.length !== target.length) {
        return false;
    }

    for (let i = 0, len = source.length; i < len; i++) {
        //Checks whether the order of both the arrays are maintained.
        if (comparer && !comparer(source[i], target[i])) {
            return false;
        }
    }

    return true;
}

export const approvalPolicyTypeIdString: string = "8C6F20A7-A545-4486-9777-F762FAFE0D4D";
export const preCheckApprovalPolicyTypeIdString: string = "0F52A19B-C67E-468F-B8EB-0AE83B532C99";
export const postCheckApprovalPolicyTypeIdString: string = "06441319-13FB-4756-B198-C2DA116894A4";
export const approvalPolicyTypeName: string = "Approval";
export const preApprovalPolicyTypeName: string = "Pre-check approval";
export const postApprovalPolicyTypeName: string = "Post-check approval";

export function getApprovalTypeName(id: string): string {
    // tslint:disable-next-line:whitespace
    switch (id?.toUpperCase()) {
        case preCheckApprovalPolicyTypeIdString:
            return preApprovalPolicyTypeName;
        case postCheckApprovalPolicyTypeIdString:
            return postApprovalPolicyTypeName;
        default:
            return approvalPolicyTypeName;
    }
}
